import GlobalTabs from './GlobalTabs';

export default GlobalTabs;
